<template>
    <div id="auto-complete-div" class="auto-complete" v-show="contacts_search.count > 0" >
        <div
            class="contact"
            :class="{ 'selected': contacts_search.outer_focus === index  }"
            v-for="(contact,index) in contacts_search.items"
            :id="contact.id"
            :key="'c_a_b' + index"
            @mousedown="onContacClick(index)"
            v-scroll-to-element="index === contacts_search.outer_focus "
        >
            <div>
                {{contact.name}}
            </div>
            <div>
                <span class="pre-match">{{contacts_search.matches[contact.id][0]}}</span>
                <span class="matched">{{contacts_search.matches[contact.id][1]}}</span>
                <span class="pos-match">{{contacts_search.matches[contact.id][2]}}</span>
            </div>
        </div>
    </div>
</template>

<script setup>

import { defineEmits, defineProps, defineExpose } from 'vue';
import { onBeforeMount, onUnmounted }             from 'vue';
import { reactive, watch }                        from 'vue';
import ContactsFilterCollection                   from '@/js/Contacts/Collections/ContactsFilterCollection.js';

const props = defineProps({
  contacts_controller : {
    required: true,
  },

  auto_complete_search: {
    required: true,
  }
})

const emit = defineEmits([
  'contactsAutoCompletedSelected'
]);

const contacts_search = reactive(new ContactsFilterCollection());

onBeforeMount(() => {
  contacts_search.setSearchList(props.contacts_controller.contacts.persons);
  window.addEventListener('keydown', keyDownEvents);
  setContactsFilters();
})

onUnmounted(() => {
    window.removeEventListener('keydown', keyDownEvents)
})

watch(() => props.auto_complete_search, () => {
  setContactsFilters()
});

const onContacClick = (index) => {
  setSelected(index);
  contacts_search.reset();
}

const onKeyDownActivator = (event) => {
  if (props.auto_complete_search.length === 0) {
      return;
  }

  setSelected(contacts_search.outer_focus);
  contacts_search.reset();
}

const onKeyDownArrowDown = (event) => {
  contacts_search.outerFocusDown();
}

const onKeyDownArrowUp = (event) => {
  contacts_search.outerFocusUp();
}

const isAutoCompleteActive = () => {
  return contacts_search.count > 0;
}

const setContactsFilters = () => {
  contacts_search.reset();

  if (!props.auto_complete_search) {
    return;
  }

  contacts_search.setOuterFocus(0);
  contacts_search.searchIn('persons', props.auto_complete_search,  8);
}

const setSelected = (index) => {
  emit('contactsAutoCompletedSelected', contacts_search.items[index]);
}

const keyDownEvents = (event) => {
  if(contacts_search.count === 0){
      return;
  }

  if (!key_down_event_actions[event.code]) {
      return
  }

  key_down_event_actions[event.code](event);
}

const key_down_event_actions = {
    'ArrowDown' : onKeyDownArrowDown,
    'ArrowUp'   : onKeyDownArrowUp,
    'Enter'     : onKeyDownActivator,
    'Comma'     : onKeyDownActivator,
}

defineExpose({
  isActive: isAutoCompleteActive,
})

</script>